import { AppModule } from 'app/module';
import { SocialMediaLinks } from 'module/socialMediaLinks/main';
import 'module/icon/styles.scss';
import Template from './template.hbs';
import './styles.scss';

export class BsCompanyRecruiterItem extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            toggleButton: '.m-bsCompanyRecruiterItem__toggleShowMore',
            quote: '.m-bsCompanyRecruiterItem__quote',
            name: '.m-bsCompanyRecruiterItem__name',
            position: '.m-bsCompanyRecruiterItem__position',
            location: '.m-bsCompanyRecruiterItem__location',
            street: '.m-bsCompanyRecruiterItem__street',
            city: '.m-bsCompanyRecruiterItem__city',
            telephone: '.m-bsCompanyRecruiterItem__telephoneNumber',
            optionalData: '.m-bsCompanyRecruiterItem__hasOptionalData',
            inquiryButton: '.m-bsCompanyRecruiterItem__inquiryButton',
            avatar: '.m-bsCompanyRecruiterItem__avatar',
            avatarContainer: '.m-bsCompanyRecruiterItem__avatarContainer',
            socialMediaLinks: '.m-bsCompanyRecruiterItem__socialMediaLinks .m-socialMediaLinks',
        };
    }

    getPropsFromDom() {
        return {
            showMore: false,
            quote: this.dom.quote ? this.dom.quote.innerHTML : '',
            name: this.dom.name.innerText,
            position: this.dom.position ? this.dom.position.innerText : '',
            location: this.dom.location ? this.dom.location.innerText : '',
            street: this.dom.street ? this.dom.street.innerText : '',
            city: this.dom.city ? this.dom.city.innerText : '',
            telephone: this.dom.telephone ? this.dom.telephone.innerText : '',
            phoneRaw: this.dom.telephone ? this.dom.telephone.href : '',
            hasOptionalData: !!this.dom.optionalData,
            recruiterEmail: this.dom.inquiryButton
                ? this.dom.inquiryButton.getAttribute('data-recruiter-email') : false,
            userEmail: this.dom.inquiryButton
                ? this.dom.inquiryButton.getAttribute('data-user-email') : false,
            userFirstName: this.dom.inquiryButton
                ? this.dom.inquiryButton.getAttribute('data-user-firstname') : false,
            userSurName: this.dom.inquiryButton
                ? this.dom.inquiryButton.getAttribute('data-user-surname') : false,
            male: this.dom.avatarContainer
                ? (this.dom.avatarContainer.getAttribute('data-male') === 'true') : false,
            imgSrc: this.dom.avatar ? this.dom.avatar.src : false,
        };
    }

    domEvents() {
        if (this.dom.toggleButton) {
            this.dom.toggleButton.addEventListener('click', () => this.toggleRecruiterQuote());
        }
        if (this.dom.inquiryButton) {
            this.dom.inquiryButton.addEventListener('click', () => this.openInquiryModal());
        }
    }

    subs() {
        if (this.dom.socialMediaLinks) {
            this.socialMediaLinks = new SocialMediaLinks(this.dom.socialMediaLinks);
            this.props.socialMediaLinks = this.socialMediaLinks.getPropsFromDom();
        }
    }

    toggleRecruiterQuote(e) {
        if (e) e.preventDefault();
        this.events.emit('closeAllRecruiter');
        this.updateProps({ showMore: !this.props.showMore }, true);
    }

    openInquiryModal() {
        this.events.emit('openInquiryModal', this.props);
    }

    ready() {
        this.addViewportObserver();
    }

    entersViewport() {
        if (this.dom.avatar) {
            this.events.emit('updateRecruiterItemProps');
        }
    }

    afterRender() {
        if (window.self !== window.parent) {
            this.events.emit('updateIFrame');
        }
    }
}
